import React from "react";
import { Trophy } from "lucide-react";
import AccessButton from "components/button/accessbutton";
import { CATEGORY_CONFIG } from "variables/constants";
import AwardCardCompact from "./AwardCardCompact";
import { Card } from "antd";

const MyAwards = () => {

    const awards = [];

    return (
        <Card className="flex flex-col gap-6 rounded-xl border border-purple-200  bg-gradient-to-br from-white to-purple-50 dark:from-intsamis-900 dark:to-purple-900">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="p-2 rounded-full bg-gradient-to-br from-amber-400 to-orange-500">
                            <Trophy className="w-5 h-5 text-white" />
                        </div> 
                        <div>
                            <h4 className="text-[16px] title-text">
                                My Awards & Recognition
                            </h4>
                            <p className="muted-text text-[11px]">
                                Recent achievements and badges
                            </p>
                        </div>
                    </div>
                    <AccessButton 
                        label="View All Awards"
                        to="/console/employee-awards"
                        btnClass="btn-awards"
                    />
                </div>
            </div>
            <div className="pt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {awards.map((key) => {
                        const category = CATEGORY_CONFIG[key];
                        return (
                            <AwardCardCompact
                                key={category.id}
                                title={category.title}
                                date="Sept 2025"
                                icon={category.icon}
                                category={category.colorClass}
                                popoverContent={category.award}
                            />
                        );
                    })}
                </div>
            </div>
        </Card>
    )
};
export default MyAwards;